export const isValidUsername = (text) => {
	if (!text) return true
	const length = text.length
	return length >= 3 && length <= 40
}

export const isValidEmail = (text) => {
	if (text.length === 0) return true
	if (!(typeof text === 'string' || text instanceof String)) return false
	if (!text.includes('@')) return false
	if (text.split('@').length !== 2) return false
	return text.split('@')[1].includes('.')
}
